export default __webpack_public_path__ + "static/media/zoo.76cbf535.svg";